module.exports = __webpack_public_path__ + "card/img/publicCode.9b8a9d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/publicCode.jpg
// module id = mpCF
// module chunks = 1